import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";

export function LandingNav() {
  const { pathname } = useLocation();
  const { user } = useAuth();

  const navLink = (to: string, label: string, hidden?: boolean, hideOnTiny?: boolean) => (
    <Button
      variant="ghost"
      size="sm"
      asChild
      className={`px-2 text-xs sm:px-3 sm:text-sm ${hidden ? "hidden sm:inline-flex" : ""} ${hideOnTiny ? "max-[359px]:hidden" : ""} ${pathname === to ? "text-foreground font-medium" : ""}`}
    >
      <Link to={to}>{label}</Link>
    </Button>
  );

  return (
    <nav className="sticky top-0 z-40 border-b border-border/40 bg-background/80 backdrop-blur-sm">
      <div className="flex items-center justify-between px-4 py-3 sm:container sm:py-4">
        <Link to="/" className="shrink-0 text-xl font-bold tracking-tight sm:text-2xl">
          <span className="text-gradient">Menuz</span>AI
        </Link>
        <div className="flex items-center gap-0.5 sm:gap-1">
          {navLink("/funcionalidades", "Funcionalidades", true)}
          {navLink("/pricing", "Planos", false, true)}
          {navLink("/sobre", "Sobre", true)}
          {user ? (
            <Button variant="hero" size="sm" asChild className="ml-1 h-11 px-3 text-xs sm:ml-2 sm:px-4 sm:text-sm">
              <Link to="/dashboard">Meu painel</Link>
            </Button>
          ) : (
            <>
              {navLink("/entrar?mode=login", "Entrar")}
              <Button variant="hero" size="sm" asChild className="ml-1 h-11 px-3 text-xs sm:ml-2 sm:px-4 sm:text-sm">
                <Link to="/entrar">Começar agora</Link>
              </Button>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}
